<template>
    <div>
        <form data-vv-scope="itemForm">
            <table class="table table-bordered">
                <colgroup>
                    <col width="50">
                    <col width="300">
                    <col>
                    <col width="150">
                    <col width="100" v-if="isConsultationInProgress">
                </colgroup>
                <thead>
                    <th>
                        #
                    </th>
                    <th>
                        Item type
                    </th>
                    <th>
                        Item Name
                    </th>
                    <th class="text-right">
                        Price (RM)
                    </th>
                    <th v-if="isConsultationInProgress">Delete</th>
                </thead>
                <tbody>
                    <tr v-if="value.length===0">
                        <td colspan="5" class="text-center font-italic">
                            No item added yet.
                        </td>
                    </tr>
                    <tr v-for="(item, index) in value" :key="index">
                        <td>{{ index + 1}}</td>
                        <td>
                            <template v-if="isConsultationInProgress">
                                <input type="text" class="form-control" :name="`itenType${index}`" data-vv-validate-on="blur" data-vv-as="item type" v-validate="'required'" v-model="item.type" :class="{
                                    'is-invalid':  validationErrors.has(`itemForm.itenType${index}`)
                                }">
                                <div v-show="validationErrors.has(`itemForm.itenType${index}`)" class="invalid-feedback">
                                    {{ validationErrors.first(`itemForm.itenType${index}`) }}
                                </div>
                            </template>
                            <span v-else>
                                {{ item.type }}
                            </span>
                        </td>
                        <td>
                            <template v-if="isConsultationInProgress">
                                <input type="text" class="form-control" :name="`itemName${index}`" data-vv-validate-on="blur" data-vv-as="item name" v-validate="'required'" v-model="item.name" :class="{
                                    'is-invalid':  validationErrors.has(`itemForm.itemName${index}`)
                                }">
                                <div v-show="validationErrors.has(`itemForm.itemName${index}`)" class="invalid-feedback">
                                    {{ validationErrors.first(`itemForm.itemName${index}`) }}
                                </div>
                            </template>
                            <span v-else>
                                {{ item.name }}
                            </span>
                        </td>
                        <td>
                            <template v-if="isConsultationInProgress">
                                <input type="text" class="form-control text-right" :name="`itemPrice${index}`" data-vv-validate-on="blur" data-vv-as="price" v-validate="'required|decimal:2|min_value:0.01'" v-model.number="item.price" :class="{
                                        'is-invalid':  validationErrors.has(`itemForm.itemPrice${index}`)
                                    }">
                                <div v-show="validationErrors.has(`itemForm.itemPrice${index}`)" class="invalid-feedback">
                                    {{ validationErrors.first(`itemForm.itemPrice${index}`) }}
                                </div>
                            </template>
                            <div v-else class="text-right">
                            <span >
                                {{ item.price.toFixed(2) }}
                            </span>
                            </div>
                        </td>
                        <td v-if="isConsultationInProgress">
                            <button type="button" class="btn btn-danger" @click="deleteItem(index)">Delete</button>
                        </td>
                    </tr>
                    <tr  v-if="isConsultationInProgress">
                        <td colspan="5">
                            <button type="button" class="btn btn-primary btn-primary-insv" @click="addItem">
                                Add New Item
                            </button>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th colspan="3" class="text-right">
                            Total Price (RM)
                        </th>
                        <td class="text-right">
                            <template v-if="isConsultationInProgress">
                                {{itemsPriceTotal}}
                            </template>
                            <template v-else>
                                {{totalPrice.toFixed(2)}}
                            </template>
                        </td>
                        <td v-if="isConsultationInProgress"></td>
                    </tr>
                </tfoot>
            </table>
        </form>
    </div>
</template>

<script>
export default {
    'name': 'DoctorConsultationPrice',
    'props': {
        'isConsultationInProgress': {
            'type': Boolean,
            'default': false
        },
        'totalPrice': {
            'type': Number,
            'default': 0
        },
        'value': {
            'type': Array,
            'required': true
        }
    },
    'computed': {
        itemsPriceTotal () {
            if (!this.validationErrors.any('itemForm')) {
                if (this.isConsultationInProgress) {
                    let items = this.value;

                    let prices = items.map((i) => i.price);

                    let total = prices.reduce((a, b) => {
                        return a + b;
                    }, 0);

                    return total.toFixed(2);
                }
            }
            return '-';
        }
    },
    'methods': {
        addItem () {
            this.validateForm().then(() => {
                if (this.value.length === 0) {
                    this.value.push({
                        'type': 'Delivery Cost',
                        'name': 'Delivery Cost',
                        'price': 0
                    });
                }

                this.value.push({
                    'type': 'Medication',
                    'name': '',
                    'price': 0
                });
            });
        },
        deleteItem (index) {
            this.value.splice(index, 1);
        },
        validateForm () {
            return this.$validator.validateAll('itemForm');
        }
    }
};
</script>

<style>

</style>
